/**
 * THE rule for when closing the Capture window throws the capture away.
 *
 * It lives here, named and tested, because getting it wrong is invisible and
 * expensive. `'error'` used to be in this list, and the error state ALWAYS ends
 * at a close -- there is nothing else on screen to press. So every failed
 * capture deleted the only evidence that it had ever been attempted, and a
 * person who tried and failed became indistinguishable from a person who never
 * tried.
 *
 * **What that cost, 2026-09-28.** Marcel reported "Gabriel is the only person
 * that cannot capture an incoming invoice via upload". Five read-only passes over
 * the live system could not establish whether Gabriel had ever pressed the
 * button, because any attempt had erased itself. A failed row carries the
 * filename, the time, the uploader and the reader's own error message. That is
 * the entire answer, and it was being thrown away on the way out.
 *
 * Abandoning a capture that SUCCEEDED is a different thing and still cleans up:
 * the file was read, the user chose not to use it, and the row is noise.
 */
export const DISCARD_ON_CLOSE_STATES = Object.freeze(['results', 'addPartner']);

/**
 * @param {string} uploadState - the Capture window's state when it was closed.
 * @returns {boolean} true when the capture record should be deleted.
 */
export const shouldDiscardOnClose = (uploadState) =>
  DISCARD_ON_CLOSE_STATES.includes(uploadState);

export default shouldDiscardOnClose;
